/* import __COLOCATED_TEMPLATE__ from './posting-create-header.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { get } from '@ember/object';
import { action } from '@ember/object';
import { showModal } from 'sh-www/utils/modal-controls';

import Config from 'sh-www/config/environment';

class PostingCreateHeader extends Component {
  @service
  media;

  /**
   * @property {Ember.service}
   */
  @service('states/routes/posting-create')
  state;

  @service('state-managers/routes/posting-create')
  stateManager;

  @service
  router;

  /**
   * @type {String}   Uri to dashboard
   */
  get dashboardUrl() {
    return `${Config.legacyUrl}/dashboard`;
  }

  get isQuote() {
    return get(this.state, 'isDirectHireMode')
      && this.router.currentRoute.queryParams.type === 'quote';
  }

  /**
   * @type {Boolean}    true if we are in the direct hire mode.
   */
  get _isDirectHireMode() {
    return get(this.state, 'isDirectHireMode');
  }

  /**
   * @type {Boolean}    True if we are editing a posting or creating a new one.
   */
  get _isEditing() {
    get(this.state, 'editingPosting');
  }

  /**
   * Called when user clicks to cancel the existing posting.
   *
   * @param {MouseEvent} e
   */
  @action
  onCancelClicked(e) {
    e.stopPropagation();
    e.preventDefault();

    if (!this.state.isAnyInfoSuppliedInCreationForm) {
      // we don't have any info supplied, so just reset and go back to where we came from.
      this.stateManager.init();
      this.stateManager.toggleConfirmDiscardData(false);
      window.history.back();
      return;
    }

    const isEditing = this._isEditing;
    const isDirectHire = this._isDirectHireMode;

    let titleText = '';
    let bodyText = '';

    if (isDirectHire) {
      titleText = 'Discard project?';
      bodyText = 'Are you sure you want to discard this project?';
    } else {
      titleText = isEditing ? 'Discard changes?' : 'Discard posting?';
      bodyText = isEditing ?
        'You will lose any changes you have made.' :
        'Are you sure you want to discard this posting?';
    }

    showModal(this, 'confirmation', {
      titleText,
      bodyText,
      actionButtonText: 'Discard',
      cancelButtonText: 'Cancel',
      isShowCancelButton: true,
      confirmAction: () => {
        this.stateManager.init();
        this.stateManager.toggleConfirmDiscardData(false);
        window.history.back();
      },
    });
  }
}

export default PostingCreateHeader;
